import React, { createContext, useState, useContext, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => useContext(CurrencyContext);

const API_URL = 'https://v6.exchangerate-api.com/v6/c7b9087fd83cb731288ce7a9/latest/USD';

export const CurrencyProvider = ({ children }) => {
    const [currency, setCurrency] = useState(localStorage.getItem('currency') || 'USD');
    const [rate, setRate] = useState(() => {
        // Try to get cached rate from localStorage
        const cached = localStorage.getItem('exchangeRate');
        if (cached) {
            const { rate: cachedRate, timestamp } = JSON.parse(cached);
            // Check if cache is less than 24 hours old
            if (Date.now() - timestamp < 24 * 60 * 60 * 1000) {
                return cachedRate;
            }
        }
        // return 0.92; // Fallback rate
    });
    const [loading, setLoading] = useState(false);

    // Fetch exchange rate from Exchangerate-API
    useEffect(() => {
        const fetchExchangeRate = async () => {
            try {
                setLoading(true);
                console.log('🔄 Fetching exchange rate from Exchangerate-API...');

                const response = await fetch(API_URL);
                const data = await response.json();

                console.log('📊 API Response:', data);

                if (data && data.result === 'success' && data.conversion_rates && data.conversion_rates.EUR) {
                    const newRate = data.conversion_rates.EUR;
                    setRate(newRate);
                    // Cache the rate with timestamp
                    localStorage.setItem('exchangeRate', JSON.stringify({
                        rate: newRate,
                        timestamp: Date.now()
                    }));
                    console.log('✅ Exchange rate updated:', newRate, 'EUR per 1 USD');
                } else {
                    console.error('❌ Invalid API response');
                }
            } catch (error) {
                console.error('❌ Failed to fetch exchange rate:', error);
                // Try to use cached rate
                const cached = localStorage.getItem('exchangeRate');
                if (cached) {
                    const { rate: cachedRate } = JSON.parse(cached);
                    console.log('📦 Using cached rate:', cachedRate);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchExchangeRate();

        // Refresh rate every hour
        const interval = setInterval(fetchExchangeRate, 60 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        localStorage.setItem('currency', currency);
    }, [currency]);

    const formatPrice = (priceInUSD) => {
        if (currency === 'EUR') {
            return (priceInUSD * rate).toFixed(2);
        }
        return parseFloat(priceInUSD).toFixed(2);
    };

    const getSymbol = () => {
        return currency === 'EUR' ? '€' : '$';
    };

    const convertToUSD = (amount) => {
        if (currency === 'EUR') {
            return (amount / rate).toFixed(2);
        }
        return parseFloat(amount).toFixed(2);
    };

    return (
        <CurrencyContext.Provider value={{ currency, setCurrency, formatPrice, getSymbol, convertToUSD, rate, loading }}>
            {children}
        </CurrencyContext.Provider>
    );
};
